// Copyright (c) 2017 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';

export const getDefaultState = () =>
    new SearchFilters({
        filterBy: '',
        query: '',
        sortBy: ['account'],
        sortDirection: 'ASC'
    });

export default SearchFilters;




// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/state/search-filters.js